import { userService } from "../services";
import { router } from "../helpers";
import Swal from 'sweetalert2'
import i18n from "../helpers/vue-i18n";

const user = JSON.parse(localStorage.getItem("instantcare_user"));
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        async login({ dispatch, commit }, { username, password }) {
            commit("loginRequest", { username });
            userService.login(username, password).then(
                user => {
                    if (user.token){
                        commit("loginSuccess", user);
                        router.push("/");
                    }
                    if (user.two_factor_enabled){
                        Swal.fire({
                            title: "InstantCare",
                            text: i18n.t('two_factor'),
                            input: 'text',
                            inputPlaceholder: '2FA Code',
                            showCloseButton: true,       
                        }).then(function(code){
                            userService.login2fa(username, password, code.value)
                            .then(
                                user => {
                                    commit("loginSuccess", user);
                                    router.push("/");
                                },
                                error => {
                                    commit("loginFailure", error);
                                    dispatch("alert/error", error, { root: true });
                                }
                            );
                        });
                    }
                },
                error => {
                    commit("loginFailure", error);
                    dispatch("alert/error", error, { root: true });
                }
            );
        },
        logout({ commit }) {
            userService.logout();
            commit("logout");
        }
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
            localStorage.setItem("instantcare_user", JSON.stringify(user));
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
        }
    }
};
